import IMInventoryOutput from './IMInventoryOutput';
export default IMInventoryOutput;
